import styled                     from 'styled-components';
import { IconButton, Typography } from '@mui/material';

export const PopperWrapper = styled.div<{ width?: string }>(
  ({ width }) => `
    width: ${width ? width : '390px'};
    padding: 14px 0;
    position: relative;
  `
);

export const PopperHeader = styled(Typography)`
  color: ${({ theme: { palette } }) => (palette.common.black)};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 14px;
  padding: 0 14px;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 3px;
  right: 3px;
`;
